import * as React from 'react';
import type { InjectedIntlProps } from 'react-intl';
import { injectIntl, FormattedMessage } from 'react-intl';
import { ErrorMessage, ErrorMessageLink } from 'view/common/error-message';
import messages from './messages';
import type { FormErrors } from '../types';

interface FormErrorMessageProps {
    errors: FormErrors;
}

// This is a class component so it can be used inside <Autofocus />
export class FormErrorMessage extends React.Component<FormErrorMessageProps & InjectedIntlProps> {
    render() {
        const { errors, intl } = this.props;
        const submissionError = errors.submissionError;
        const errorTitle = intl.formatMessage(messages.errorMessageTitle);
        let errorMessage;

        if (submissionError && 'isOfflineError' in submissionError && submissionError.isOfflineError) {
            errorMessage = intl.formatMessage(messages.errorMessageOfflineText);
        } else if (submissionError && 'isGeneric' in submissionError && submissionError.isGeneric) {
            errorMessage = (
                <FormattedMessage
                    {...messages.errorMessageText}
                    values={{
                        contactLink: (
                            <ErrorMessageLink
                                href={errors.contactLink}
                                target="_blank"
                                actionSubjectId="errorMessageContactLink"
                            >
                                <FormattedMessage {...messages.errorMessageContactLink} />
                            </ErrorMessageLink>
                        ),
                    }}
                />
            );
        } else {
            // pre-translated error message from the backend
            errorMessage = submissionError && 'errorMessage' in submissionError && submissionError.errorMessage;
        }

        return <ErrorMessage title={errorTitle} message={errorMessage} />;
    }
}

export default injectIntl(FormErrorMessage);
